import { Component, ViewChild, OnInit } from '@angular/core';
import { FeedbackComponent } from 'src/app/general-components/feedback/feedback.component';
import { FeedbackType } from 'src/app/general-components/feedback/feedback-type';
import { HttpErrorResponse } from '@angular/common/http';
import { Profile } from 'src/app/general-components/profile/profile';
import { AuthService } from 'src/app/auth/auth.service';
import { IndiCustomer } from '../../salesorders/indi-customer';
import { User } from '../../salesorders/user';
import { NewMancoService } from './new-manco.service';
import { OrderDetails } from './order-details';
import { MancoOrderResponse, MancoOrderRequest } from './manco-order-request';
import { NewMancoSearchFormComponent } from './new-manco-search-form/new-manco-search-form.component';
import { NewMancoFormComponent } from './new-manco-form/new-manco-form.component';

@Component({
  selector: 'app-new-manco',
  templateUrl: './new-manco.component.html',
  styleUrls: ['./new-manco.component.scss'],
})
export class NewMancoComponent implements OnInit {
  @ViewChild(FeedbackComponent) feedbackComponent!: FeedbackComponent;
  @ViewChild(NewMancoSearchFormComponent) searchFormComponent!: NewMancoSearchFormComponent;
  @ViewChild(NewMancoFormComponent) newMancoFormComponent!: NewMancoFormComponent;

  orderNumber: string = '';
  freshdeskTicketNumber: string = '';
  orderDetails?: OrderDetails;
  indiCustomer?: IndiCustomer;
  users: User[] = [];
  mancoOrderResponse?: MancoOrderResponse;
  mancoOrderError?: HttpErrorResponse;
  profile: Profile = {} as unknown as Profile;

  isLoadingSearch: boolean = false;
  isLoadingResponse: boolean = false;

  constructor(
    private service: NewMancoService,
    private authService: AuthService
  ) {}

  ngOnInit(): void {
    this.profile = this.authService.getUserInfo();
  }

  handleSearchSubmit(): void {
    this.isLoadingSearch = true;
    this.mancoOrderError = undefined;
    this.mancoOrderResponse = undefined;

    this.service.getCombinedData(this.orderNumber).subscribe({
      next: combined => {
        this.orderDetails = combined.orderDetails;
        this.indiCustomer = combined.indiCustomer;
        this.users = combined.users;
        this.isLoadingSearch = false;
      },
      error: error => {
        console.error('Failed to look up orderlines for order: ' + this.orderNumber, error);
        this.feedbackComponent.showFeedback(
          '',
          FeedbackType.error,
          'We konden de orderregels niet ophalen.',
          undefined,
          false
        );
        this.isLoadingSearch = false;
        this.fadeOutFeedback();
      },
    });
  }

  handleSearchReset(): void {
    this.orderNumber = '';
    this.freshdeskTicketNumber = '';
    this.orderDetails = undefined;
    this.indiCustomer = undefined;
    this.users = [];
    this.mancoOrderError = undefined;
    this.mancoOrderResponse = undefined;
  }

  handleMancoRequestSubmit(mancoRequest: MancoOrderRequest): void {
    mancoRequest.freshdeskTicketNumber = this.freshdeskTicketNumber;
    mancoRequest.createdByHint = this.profile.fullName;

    this.mancoOrderError = undefined;
    this.isLoadingResponse = true;
    this.service.createMancoOrder(mancoRequest).subscribe({
      next: (mancoOrderResponse: MancoOrderResponse) => {
        mancoOrderResponse.request = mancoRequest;
        this.isLoadingResponse = false;

        this.newMancoFormComponent.resetForm();
        this.searchFormComponent.forceReset();
        this.mancoOrderResponse = mancoOrderResponse;
      },
      error: (error: HttpErrorResponse) => {
        console.error('Something went wrong with the manco order request: ', error);

        this.isLoadingResponse = false;
        this.mancoOrderError = error;
      },
    });
  }

  fadeOutFeedback(): void {
    this.feedbackComponent.fadeOut(3000);
  }

  hideOrderSummary(): void {
    this.mancoOrderResponse = undefined;
  }

  hideOrderError(): void {
    this.mancoOrderError = undefined;
  }
}
